import styled from 'styled-components';

interface StyledProps {
  active: boolean;
}

export const StyledWrapper = styled.div<StyledProps>`
  .caption-container {
    opacity: ${props => (props.active ? '1' : '0')};
    position: fixed;
    max-height: 14%;
    overflow: auto;
    padding: 10px 20px;
    background: rgba(0, 0, 0, 0.6);
    color: rgb(255, 255, 255);
    font-size: 1.2rem;
    line-height: 1.5;
    border-radius: 8px;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 6px;
    text-align: center;
    margin: 20px 50px;
    z-index: 1000;
    scrollbar-width: thin; /* For Firefox */
    scrollbar-color: rgba(255, 255, 255, 0.5) rgba(0, 0, 0, 0.4);
  }

  .caption-container::-webkit-scrollbar {
    width: 8px;
  }

  .caption-container::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.4); /* Track background */
    border-radius: 8px;
  }

  .caption-container::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.5); /* Thumb color */
    border-radius: 8px;
    border: 2px solid rgba(0, 0, 0, 0.4); /* Creates padding around thumb */
  }

  .caption-container::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.8); /* Lighter thumb on hover */
  }

  .caption-container span {
    display: inline-block;
    animation: fadeIn 0.3s ease-in-out;
    padding-left: 5px;
  }

  /* Optional fade-in animation */
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;